package horcrux.frontend.common.views.chat.context

import horcrux.common.api.dtos.types.ContextDocumentChunkAndMetadata
import horcrux.frontend.common.BooleanState
import mui.material.Button
import mui.material.Dialog
import mui.material.DialogActions
import mui.material.DialogContent
import mui.material.DialogContentText
import mui.material.Typography
import mui.system.sx
import react.FC
import react.Props
import web.cssom.WhiteSpace

external interface ContextDocumentChunkDetailsDialogProps : Props {
    var showDialogState: BooleanState
    var contextDocumentChunkAndMetadata: ContextDocumentChunkAndMetadata
}

fun ContextDocumentChunkAndMetadata.toDisplayString(): String =
    """Document ID: ${this.documentChunkID.documentID.betterToString()}
       
       Document Name: ${this.documentMetadata.documentName.betterToString()}
       
       Document URL: ${this.documentMetadata.documentURL.betterToString()}
       
       Document Chunk Number: ${this.documentChunkID.documentChunkIndex.betterToString()}
       
       Relevancy Score: ${this.relevancyScore.betterToString()}
    """.trimIndent()

val ContextDocumentChunkDetailsDialog = FC<ContextDocumentChunkDetailsDialogProps> { props ->
    Dialog {
        this.title = "Document Chunk Details"
        this.open = props.showDialogState.get()
        this.onClose = { _, _ -> props.showDialogState.setFalse() }
        DialogContent {
            DialogContentText {
                +"Document Chunk Details"
            }
            Typography {
                this.sx {
                    this.whiteSpace = WhiteSpace.preLine
                }
                +"${props.contextDocumentChunkAndMetadata.toDisplayString()}"
            }
        }
        DialogActions {
            Button {
                +"OK"
                this.onClick = { props.showDialogState.set(false) }
            }
        }
    }
}
